import { accountHttpApi } from 'api';
import { getUserTokenInfo, onAuthStorageChange } from 'api/auth-storage';
import { bootRecaptcha } from 'api/recaptcha';
import { bootService } from 'shared/boot';

bootService('account');
bootRecaptcha();
updateApiBearerToken();
onAuthStorageChange(updateApiBearerToken);

function updateApiBearerToken () {
  const tokenInfo = getUserTokenInfo();
  if (!tokenInfo) return;
  accountHttpApi.setBearerToken(tokenInfo.token);
}
